module.exports = __webpack_public_path__ + "img/cricket-dark.5ca514df.svg";